import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../custom/StateProvider';
//import {contentPermissions} from "../../custom/feathersAuthorisation";
//import BankDetails from './components/bankDetails';
import CompleteWithdrawal from './components/withdrawal';
import {API} from "../../../config";
import Utils from "../../custom/utils";
import {Grid, TableFilterRow, TableHeaderRow, VirtualTable} from "@devexpress/dx-react-grid-material-ui";
import {FilteringState, IntegratedFiltering, IntegratedSorting, SortingState} from "@devexpress/dx-react-grid";
import {connect} from "react-redux";

const withdrawals = API.service('withdrawal');

const moment = require('moment');

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    header:{
        backgroundColor:"#262933",
        padding:'18px',
        paddingTop:'17px',
        color:'white'
    }
});

class Outbound extends Component {
    state = {
        outbound: [],
    }

    fetchData = () => {
        const app = this;
        if(this.nameSearch !== ''){
            
        }

        console.log(this.props.user.affiliate);

        withdrawals.find({query:{incl:['investor']}}).then(inv =>{
          let outbound = [];
          inv.data.forEach((v)=>{
            console.log(v);
            if((!Utils.isEmpty(this.props.user.affiliate) && v.investors[0]._affiliate === this.props.user.affiliate) || Utils.isEmpty(this.props.user.affiliate)) {
              outbound.push(v);
            }
          });
          app.setState({
            outbound:outbound
          })
        }).catch(e=>{
            console.log('Error Loading:', e);
            app.setState({
                error:'Error: ' + e
            })
        })
    }

    investorState(state) {
        let InvStatus = Utils.returnState(state);
        return(
          <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
        )
    }

    depositState(state) {
        let states = Utils.returnWithdrawalState(state)
        return(
          <div className={'kyc-label ' + states[0]}>{states[1]}</div>
        )
    }

    getAmountWithCurrency(amount, currencyType){
        let currency = Utils.getCurrency(currencyType.toUpperCase());
        return (currency.currency_symbol + Utils.addThousandCommas(amount, '0,0.00').toString())
    }

    componentDidMount = () => {
        this.fetchData();
    }

    render() {

        const {classes} = this.props;

        return (
                <React.Fragment>
                    <div className={classes.header}>
                        <h4>Outbound Withdrawals</h4>
                    </div>
                    <Grid
                      //{ name: '_action', title: 'Actions', getCellValue: row=>(<Deposit row={row} />)
                      rows={this.state.outbound}
                      columns={[
                          { name: '_ts_created', title: 'Date', getCellValue: row => (row._ts_created ? moment(row._ts_created).format('YYYY-MM-DD'): undefined)  },
                          { name: '_account', title: 'Account' },
                          { name: '_name', title: 'Name', getCellValue: row => (row.investors ? row.investors[0]._firstname + ' ' + row.investors[0]._surname: undefined) },
                          { name: '_email', title: 'Email', getCellValue: row => (row.investors ? row.investors[0]._email: undefined) },
                          { name: '_state', title: 'State', getCellValue: row => (row.investors ? this.investorState(row.investors[0]._states): undefined) },
                          { name: '_withdraw_via', title: 'Withdraw By' },
                          { name: '_amount', title: 'Amount', getCellValue: row=> (this.getAmountWithCurrency(row._amount, row._currency)) },
                          { name: '_fees', title: 'Fees', getCellValue: row=> (this.getAmountWithCurrency(row._fee, row._currency)) },
                          { name: '_currency', title: 'Currency' },
                          { name: '_status', title: 'Status', getCellValue: row => (row._status ? this.depositState(row._status): undefined) },
                          { name: '_complete', title: 'Actions', getCellValue: row =>  (<CompleteWithdrawal row={row} />) },

                      ]}>
                        <SortingState
                          defaultSorting={[{ columnName: '_timestamp', direction: 'desc' }]}
                        />
                        <IntegratedSorting />
                        <FilteringState defaultFilters={[]} />
                        <IntegratedFiltering />
                        <VirtualTable height={"auto"}/>
                        <TableHeaderRow showSortingControls />
                        <TableFilterRow />
                    </Grid>
                </React.Fragment>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Outbound))));
